export const initialState = () => {
    return {
        /*
        *  TRANSLATIONS
        */
        translationsLoaded: false,
        type: null,
        redirectPage: null,
        globals: {},
        page: {},
        jobs: {},

        /*
        *  SEO
        */

        seo: {
            'path': ''
        }
    }
}
